exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fontStyle[data-v-d16cba12]{font-size:12px}.errorStyle[data-v-d16cba12]{font-weight:bolder;color:red}.card[data-v-d16cba12]{background:#fff;border-radius:10px;transition:.3s ease-in-out}.card-body[data-v-d16cba12]{padding:0!important}.card[data-v-d16cba12]:hover{transform:translateY(-3px);box-shadow:0 4px 8px rgba(0,0,0,.2)}h6[data-v-d16cba12]{margin-bottom:5px;color:#333}p[data-v-d16cba12]{margin-bottom:10px;font-size:14px;color:#555}", ""]);

// exports
